import useUser from '@hooks/auth/useUser';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { pushPendingAuthEvent } from '@utils/authEventUtils';
import { reissueAndStoreToken } from '@utils/authUtils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useOnIdentifySuccess(refreshToken: string) {
    const toast = useToast();
    const { replace } = useFlow();
    const { getUserProfile } = useUser();
    const { t } = useTranslation('common');

    const setToken = async () => {
        try {
            // 인터셉터의 재발급과 겹치면 refreshToken이 두 번 회전되므로 공유 재발급을 쓴다.
            await reissueAndStoreToken(refreshToken);
            pushPendingAuthEvent();
            getUserProfile();
            replace('MainActivity', {}, { animate: false });
        } catch (e) {
            replace('MainActivity', {}, { animate: false });
            toast.error(t('identifyFailed'));
            console.error('본인증 후 오류 ', e);
        }
    };
    useEffect(() => {
        setToken();
    }, [refreshToken]);
}

export default useOnIdentifySuccess;
